"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFindTaskTypeById = void 0;
const core_ui_1 = require("@sierralabs/core-ui");
function useFindTaskTypeById(id) {
    return (0, core_ui_1.useApiGet)(`task-types/${id}`);
}
exports.useFindTaskTypeById = useFindTaskTypeById;
//# sourceMappingURL=useFindTaskTypeById.js.map